// Firebase Auth SDK error codes returned when reloading current user after verify-email flow.
export enum AUTH_ACTION_VERIFY_RELOAD_ERROR_CODE {
    networkRequestFailed = 'auth/network-request-failed',
    tooManyRequests = 'auth/too-many-requests',
    userTokenExpired = 'auth/user-token-expired',
    invalidUserToken = 'auth/invalid-user-token',
    userDisabled = 'auth/user-disabled',
    userNotFound = 'auth/user-not-found',
}
